import axios from "axios";
import * as actionType from "../../constant/actionType";
export const UpdateOverrideProviderDocsStatus =
  (APIData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "patch",
        data: APIData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/provider/UpdateOverrideProviderDocsStatus`,
      });
      return response.data;
    } catch (error) {
      return error.response?.data || { success: false, message: error.message };
    }
  };
